export const adminCustomerSalesStatuses = [
    'sold',
    'not_sold',
    'new',
    'no_response',
    'connection_refused',
    'call_back'
];
export const adminCustomerPlanOptions = [
    { code: 'none', labelKey: 'admin.customers.planOptions.none' },
    {
        code: 'system-diagnostics:default',
        labelKey: 'admin.customers.planOptions.systemDiagnostics'
    },
    { code: 'caredesk-toolkit:default', labelKey: 'admin.customers.planOptions.caredeskToolkit' },
    { code: 'smart-care:6-months', labelKey: 'admin.customers.planOptions.smartCare6' },
    { code: 'smart-care:12-months', labelKey: 'admin.customers.planOptions.smartCare12' },
    { code: 'smart-care:36-months', labelKey: 'admin.customers.planOptions.smartCare36' },
    { code: 'smart-care:60-months', labelKey: 'admin.customers.planOptions.smartCare60' },
    { code: 'total-care-vip:6-months', labelKey: 'admin.customers.planOptions.totalCareVip6' },
    { code: 'total-care-vip:12-months', labelKey: 'admin.customers.planOptions.totalCareVip12' },
    { code: 'total-care-vip:36-months', labelKey: 'admin.customers.planOptions.totalCareVip36' },
    { code: 'total-care-vip:60-months', labelKey: 'admin.customers.planOptions.totalCareVip60' },
    {
        code: 'personal-care-360:12-months',
        labelKey: 'admin.customers.planOptions.personalCare36012'
    },
    {
        code: 'personal-care-360:24-months',
        labelKey: 'admin.customers.planOptions.personalCare36024'
    },
    {
        code: 'personal-care-360:36-months',
        labelKey: 'admin.customers.planOptions.personalCare36036'
    },
    { code: 'custom', labelKey: 'admin.customers.planOptions.custom' }
];
export const adminCustomerPlanLabelKey = (code) => adminCustomerPlanOptions.find((option) => option.code === code)?.labelKey;
